import { NgModule } from '@angular/core';
import { SharedModule } from '../../../sub-modules/SharedModule';
import { FileTypeIconPipe } from './pipes/file-type-icon.pipe';
import { OldMediaPlayerComponent } from './old-media-player.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { VideoViewerComponent } from './components/video-viewer/video-viewer.component';
import { AudioViewerComponent } from './components/audio-viewer/audio-viewer.component';
import { ImageViewerComponent } from './components/image-viewer/image-viewer.component';
import { UploadProgressViewerComponent } from './components/upload-progress-viewer/upload-progress-viewer.component';
import { AssetUploadService } from './services/asset-upload.service';
import { SubsectionEventService } from './services/subsection-event.service';
import { AnnotationEventSubscriptionService } from './services/annotation-event-subscription.service';
import { AnnotationApiService } from './services/annotation-api.service';
import { AnnotationPluginEventService } from './services/annotation-plugin-event.service';
import { FileTranscodeService } from './services/file-transcode.service';
import { VideoViewerService } from './components/video-viewer/video-viewer.service';

@NgModule({
  imports: [SharedModule, FileTypeIconPipe],
  declarations: [
    OldMediaPlayerComponent,
    PdfViewerComponent,
    VideoViewerComponent,
    AudioViewerComponent,
    ImageViewerComponent,
    UploadProgressViewerComponent,
  ],
  exports: [OldMediaPlayerComponent],
  providers: [
    AssetUploadService,
    SubsectionEventService,
    AnnotationEventSubscriptionService,
    AnnotationApiService,
    AnnotationPluginEventService,
    FileTranscodeService,
    VideoViewerService,
  ],
})
export class OldMediaPlayerModule {}
